import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import { getVesselSales } from 'actions/vessels/sales';

import Item from './Item';

const styles = {
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%',
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

const List = ({ vesselSales, getVesselSales }) => {
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({ search: '' });
    const searchRef = useRef(null);

    useEffect(() => {
        getVesselSales({
            page: 1,
            filters: {},
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateRows = (newPage, newFilters) => {
        getVesselSales({
            page: newPage,
            filters: {
                search: newFilters.search.length !== 0 ? newFilters.search : undefined,
            },
        });
    };

    const nextPage = () => {
        const newPage = vesselSales.next;
        setPage(newPage);
        updateRows(newPage, filters);
    };

    const prevPage = () => {
        const newPage = vesselSales.previous;
        setPage(newPage);
        updateRows(newPage, filters);
    };

    const handleSearch = () => {
        const searchVal = searchRef.current ? searchRef.current.input.value : '';
        const newFilters = { ...filters, search: searchVal };
        setPage(1);
        setFilters(newFilters);
        updateRows(1, newFilters);
    };

    const vesselSalesItems = vesselSales.data;
    if (!vesselSalesItems) {
        return null;
    }

    return (
        <div>
            <div className='filter'>
                <div className='filter-row'>
                    <div className='search filter-column' style={{ width: '100%', justifyContent: 'space-between', }}>
                        <div>
                            <TextField
                                floatingLabelText='Search'
                                ref={searchRef}
                                onKeyPress={(event) => {
                                    if (event.charCode === 13) {
                                        event.preventDefault();
                                        handleSearch();
                                    }
                                }}
                            />

                            <RaisedButton
                                label='Search'
                                style={{ fontSize: '13px', margin: '0 0 0 50px' }}
                                primary
                                onClick={handleSearch}
                            />
                        </div>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                                iconStyle={styles.navigationLeft}
                                name='navigationLeft'
                                onClick={prevPage}
                            >
                                <ChevronLeft />
                            </IconButton>
                            <div className='item'>Page: {page}</div>
                            <IconButton
                                iconStyle={styles.navigationRight}
                                name='navigationRight'
                                onClick={nextPage}
                            >
                                <ChevronRight />
                            </IconButton>
                        </span>
                    </div>                        
                </div>

                <div>
                    <ul className='list-requests'>
                        {
                            vesselSalesItems.map(item => <Item key={item._id} item={item} />)
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default connect(
    (state) => {
        return {
            vesselSales: state.vesselSales,
        };
    },
    dispatch => bindActionCreators({
        getVesselSales,
    },
    dispatch),
)(List);



// WEBPACK FOOTER //
// ./app/components/Vessels/Sales/List.jsx